<template>
  <div>
    <!-- Container-fluid starts-->
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12">
          <px-card>
            <div slot="with-padding">
              <div class="row">
                <div class="col-md-2">
                  <h5>Investor Members List </h5>
                </div>
                <div class="col-md-4">
                  <b-input-group class="border rounded-pill p-1">
                    <div class="input-group-prepend border-0">
                      <button id="button-addon4" type="button" class="btn btn-link text-info"><i class="fa fa-search"></i></button>
                    </div>
                    <b-form-input
                        v-model="searchTitle"
                        placeholder="Type phone number to Search"
                        aria-describedby="button-addon4"
                        class="form-control bg-none border-0"
                    ></b-form-input>
                  </b-input-group>
                </div>
              </div>
              <div class="table-responsive datatable-vue">
                <b-table
                    striped hover
                    :items="users.data"
                    :fields="fields"
                >
                    <template #cell(actions)="row">
                      <b-button
                          size="sm"
                          variant="success"
                          class="rounded-pill px-3"
                          @click="openPromptPaymentModal(row.item)"
                      >
                        Prompt Payment
                      </b-button>

                    </template>
                </b-table>
                <b-modal
                    id="prompt-payment-modal"
                    ref="promptPaymentModal"
                    title="Prompt Payment"
                    hide-footer
                >
                  <div>
                    <b-form-group label="Enter Amount">
                      <b-form-input
                          v-model="paymentAmount"
                          type="number"
                          placeholder="Enter amount"
                      ></b-form-input>
                    </b-form-group>

                    <div class="text-right mt-3">
                      <b-button variant="secondary" class="mr-2" @click="closePromptPaymentModal">
                        Cancel
                      </b-button>
                      <b-button variant="primary" @click="submitPromptPayment">
                        Submit
                      </b-button>
                    </div>
                  </div>
                </b-modal>
              </div>

              <b-col md="6" class="mt-3 p-0">
                <b-pagination v-if="users.data && users.data.length"
                              v-model="currentPage"
                              :total-rows="users.meta.total"
                              :per-page="users.meta.per_page"
                              @change="handlePageChange"
                              class="my-0"
                ></b-pagination>
                <div class="text-center" v-else>
                  No Records Found
                </div>
              </b-col>
            </div>
          </px-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import {getRequestParams} from "@/helpers/pagination";
import {user_fields} from "@/pages/customers/fields/user_field_defs";
import Edit from "@/pages/customers/Edit.vue";
import axios from "axios";

export default {
  components:{
    'edit-customer':Edit
  },
  data() {
    return {
      otp:'',
      customer:{},
      fields: user_fields,
      totalRows: 1,
      currentPage: 1,
      perPage: 100,
      pageOptions: [100, 150, 200],
      searchTitle: "",
      show_edit:false,
      paymentAmount: 50,
      selectedCustomer: null,
    }
  },
  mounted() {
    this.retrieveUsers();
    this.$store.dispatch('updateStats');

    bus.$on('hide_edit_form',()=>{
      this.show_edit = false;
    })
  },
  computed:{
    ...mapGetters({users:'getCustomersInvestors','stats':'getStats'}),
  },
  watch: {
    users() {
      this.totalRows = this.users.meta.total;
      this.currentPage = this.users.meta.current_page;
      this.perPage = this.users.meta.per_page;
    },
    searchTitle() {
      this.retrieveUsers();
    },
  },
  methods:{
    editCustomer(customer) {
      bus.$emit('show_edit_form',customer)
    },
    retrieveUsers() {
      const params = getRequestParams(
          this.searchTitle,
          this.currentPage,
          this.perPage
      );
      this.$store.dispatch('updateCustomersInvestor',params)
    },
    handlePageChange(value) {
      this.currentPage = value
      this.retrieveUsers();
    },
    success_alert_state:function(){
      this.$swal({
        title:"Good job!",
        text:"Payment Prompt successfully done.",
        type:'success'
      });
    },
    danger_alert_state:function(message){
      this.$swal({
        title:"Error Occurred!",
        text:message,
        type:'error'
      });
    },

    openPromptPaymentModal(customer) {
      this.selectedCustomer = customer;
      this.paymentAmount = '';
      this.$refs.promptPaymentModal.show();
    },

    closePromptPaymentModal() {
      this.$refs.promptPaymentModal.hide();
    },

    submitPromptPayment() {
      if (!this.paymentAmount || this.paymentAmount <= 0) {
        this.danger_alert_state("Please enter a valid amount.");
        return;
      }

      const payload = {
        phone_number: this.selectedCustomer.phone_number,
        amount: this.paymentAmount
      };

      // Example axios call (adjust endpoint as needed)
      axios.post('/flex-investor/prompt-payment', payload)
          .then(() => {
            this.success_alert_state();
            this.closePromptPaymentModal();
            this.retrieveUsers();
          })
          .catch((error) => {
            this.danger_alert_state(error.response?.data?.message || "Something went wrong");
          });
    }
  },
}
</script>

<style scoped>
.form-control:focus {
  box-shadow: none;
}

.form-control-underlined {
  border-width: 0;
  border-bottom-width: 1px;
  border-radius: 0;
  padding-left: 0;
}

.card {
  box-shadow: 7px 7px 7px 7px rgba(50, 50, 50, 0.5) !important;
}
.card_green {
  color: #63D926 !important;
}
</style>
